var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import styled from "styled-components";
import { boxShadow } from "../../baseStyles";
import { bonfireGet } from "../../theme/utils";
import { CloseIcon } from "../Icons/CloseIcon";
var DrawerWrapperStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row-reverse nowrap;\n  position: fixed;\n  z-index: 10000;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  padding: 25px;\n  width: auto;\n  background-color: ", ";\n  ", ";\n\n  .bn-drawer-close {\n    position: absolute;\n    cursor: pointer;\n    top: 25px;\n    left: 25px;\n  }\n\n  .bn-drawer-content {\n    display: block;\n    width: 540px;\n  }\n\n  .bn-drawer-extendedcontent {\n    margin-right: 25px;\n    width: 715px;\n  }\n"], ["\n  display: flex;\n  flex-flow: row-reverse nowrap;\n  position: fixed;\n  z-index: 10000;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  padding: 25px;\n  width: auto;\n  background-color: ", ";\n  ", ";\n\n  .bn-drawer-close {\n    position: absolute;\n    cursor: pointer;\n    top: 25px;\n    left: 25px;\n  }\n\n  .bn-drawer-content {\n    display: block;\n    width: 540px;\n  }\n\n  .bn-drawer-extendedcontent {\n    margin-right: 25px;\n    width: 715px;\n  }\n"])), bonfireGet("colors", "backgroundLight"), boxShadow);
var mountEscapeListener = function (event, onRequestClose) {
    if (event.key === "Escape") {
        onRequestClose();
    }
};
/**
 * A right-hand drawer for use inline with the content area.
 * @deprecated Use Drawer instead.
 */
var DrawerRight = function (props) {
    var children = props.children, id = props.id, className = props.className, style = props.style, _a = props.isOpen, isOpen = _a === void 0 ? false : _a, onRequestClose = props.onRequestClose;
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (onRequestClose) {
            var eventHandler_1 = function (event) {
                return mountEscapeListener(event, onRequestClose);
            };
            document.addEventListener("keydown", eventHandler_1);
            return function () { return document.removeEventListener("keydown", eventHandler_1); };
        }
    }, []);
    if (React.Children.count(children) > 2) {
        throw new Error("Invalid children count. Expect 1 or 2 children. 1 child for normal drawer, 2 for extended drawer");
    }
    if (!isOpen) {
        return null;
    }
    var _b = __read(React.Children.toArray(children), 2), drawerContent = _b[0], extendedContent = _b[1];
    var drawer = (React.createElement(DrawerWrapperStyle, { ref: ref, id: id, className: className, style: style },
        React.createElement("div", { className: "bn-drawer-content" }, drawerContent),
        extendedContent && (React.createElement("div", { className: "bn-drawer-extendedcontent" }, extendedContent)),
        onRequestClose && (React.createElement(CloseIcon, { className: "bn-drawer-close", onClick: onRequestClose }))));
    return drawer;
};
export default DrawerRight;
var templateObject_1;
//# sourceMappingURL=DrawerRight.js.map